module.exports = __webpack_public_path__ + "media/images/flags/32/Comoros-71314228e28596721a901e1b140737ef.png";